const API_KEY = "AIzaSyDYPl4nSgJe5Ya2iI_6Luq8eulPDwoIpFY";

export default API_KEY;